var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.50012H11.5C10.1193 8.50012 9 7.38083 9 6.00012V1.00012M5.25 17.2501H12.75M5.25 13.5001H9M16.5 8.28566V18.5001C16.5 19.8808 15.3807 21.0001 14 21.0001H4C2.61929 21.0001 1.5 19.8808 1.5 18.5001V3.50012C1.5 2.11941 2.61929 1.00012 4 1.00012H9.21447C9.87751 1.00012 10.5134 1.26351 10.9822 1.73236L15.7678 6.51789C16.2366 6.98673 16.5 7.62261 16.5 8.28566Z",
    stroke: "#FF6019",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.32bf4fc1.svg";
export { ForwardRef as ReactComponent };